// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2U0EV","header_content":"Header_header_content__1hX6e","languagepicker":"Header_languagepicker__3IIp4"};